import { Link } from 'react-router-dom';

interface EmptyStateProps {
  type: 'no-products' | 'no-results';
  onClearFilters?: () => void;
}

const EmptyState = ({ type, onClearFilters }: EmptyStateProps) => {
  if (type === 'no-products') {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-4">
        <div className="w-32 h-32 bg-gray-100 rounded-full flex items-center justify-center mb-6">
          <i className="ri-box-3-line text-6xl text-gray-400"></i>
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-3 text-center">
          No products available yet.
        </h2>
        
        <p className="text-gray-600 text-center max-w-md mb-8">
          We are still onboarding brands and products. Please contact us to get the latest catalogue.
        </p>
        
        <Link
          to="/contact"
          className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap"
        >
          <i className="ri-mail-line"></i>
          Contact Us
        </Link>
      </div>
    );
  }

  // no-results
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <div className="w-32 h-32 bg-gray-100 rounded-full flex items-center justify-center mb-6">
        <i className="ri-search-line text-6xl text-gray-400"></i>
      </div>
      
      <h2 className="text-2xl font-bold text-gray-900 mb-3 text-center">
        No products match your filters.
      </h2>
      
      <p className="text-gray-600 text-center max-w-md mb-8">
        Try clearing filters or adjusting your search criteria to find what you're looking for.
      </p>
      
      <button
        onClick={onClearFilters}
        className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
      >
        <i className="ri-filter-off-line"></i>
        Clear All Filters
      </button>
    </div>
  );
};

export default EmptyState;
